export type CurrencyIsoType = 'GBP'

const availableCurrencies: CurrencyIsoType[] = ['GBP']

const GBP = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 4,
  minimumFractionDigits: 2,
}).format

export function formatPrice(currencyIso: CurrencyIsoType, price?: number): string {
  if (!price) {
    return 'n/a'
  }

  if (!availableCurrencies.includes(currencyIso)) {
    console.warn('Currency not supported')
    return price.toString()
  }

  const currencyFormatters = {
    GBP: GBP,
  }

  return currencyFormatters[currencyIso](price)
}
